import React, { useEffect } from 'react';

const SecurityProvider = ({ children }) => {
  useEffect(() => {
    // Set security headers using meta tags
    const securityHeaders = [
      {
        name: 'Content-Security-Policy',
        content: [
          "default-src 'self'",
          "script-src 'self' 'unsafe-inline' https://*.firebaseapp.com https://*.googleapis.com https://apis.google.com",
          "style-src 'self' 'unsafe-inline'", // Required for styled-components
          "img-src 'self' data: https:",
          "connect-src 'self' https://*.firebaseapp.com https://*.googleapis.com https://firebase.googleapis.com https://firebaseinstallations.googleapis.com",
          "form-action 'self'",
          "frame-src 'self' https://*.firebaseapp.com https://*.googleapis.com"
        ].join('; ')
      },
      {
        name: 'X-Content-Type-Options',
        content: 'nosniff'
      },
      {
        name: 'X-XSS-Protection',
        content: '1; mode=block'
      },
      {
        name: 'Referrer-Policy',
        content: 'strict-origin-when-cross-origin'
      },
      {
        name: 'Permissions-Policy',
        content: 'geolocation=(), camera=(), microphone=()'
      }
    ];

    // Add security headers as meta tags
    securityHeaders.forEach(header => {
      const meta = document.createElement('meta');
      meta.httpEquiv = header.name;
      meta.content = header.content;
      document.head.appendChild(meta);
    });

    // Handle cleanup when page becomes hidden or user leaves
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        localStorage.clear();
        sessionStorage.clear();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // Remove meta tags on unmount
      document.querySelectorAll('meta[http-equiv]').forEach(meta => {
        if (securityHeaders.some(header => header.name === meta.httpEquiv)) {
          meta.remove();
        }
      });
      // Clean up visibility change listener
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return <>{children}</>;
};

export default SecurityProvider;
